module.exports = __webpack_public_path__ + "src/app/pushNotifications/assets/iphone.png?e8c4679b72143fd987397d104dfc2a4d";